(function () {

    // this component for the cases actions on the main flows and how its interact with e-verify
    var CasesStatusesComponent = {
        bindings: {
            modalData: '<',
            hide: '&',
            everifyUtils: '<',
            onResubmit: '&',
            checkDuplicate: '&'
        },
        templateUrl: '../modules/e-verify/components/cases-statuses/cases-statuses.html',
        controllerAs: 'caseStatuses',
        controller: ['$scope', 'Upload', function ($scope, Upload) {

            // start the private attributes
            var self = this;
            var brand;
            var application_id;
            var prospect_id;
            var document;
            // end the private attributes

            // private functions
            // this when load the status to know which section to show there is 16 status
            var _logicShowCasesSections = function () {
                self.onSectionLoad = function () {
                    switch (self.everifyCase.status) {
                        case EVerifyAPI.STATUSES.SCAN_AND_UPLOAD:
                            self.formValidation = self.everifyUtils.getFormValidation($scope, 'scan-and-upload');
                            self.formValidation.onViewLoaded();
                            break;

                        case EVerifyAPI.STATUSES.DRAFT:
                            self.formValidation = self.everifyUtils.getFormValidation($scope, 'late-verify-form');
                            self.formValidation.onViewLoaded();
                            break;
                    }
                };

                switch (self.everifyCase.status) {
                    case EVerifyAPI.STATUSES.DRAFT:
                        self.sectionSrc = '../modules/e-verify/components/cases-statuses/statuses/drafted.html';

                        if (
                            self.checkEverifyStatus &&
                            self.checkEverifyStatus['hire_date_past_due'] &&
                            !self.innerDetails['reason_for_delay_code']
                        ) {
                            self.actions = [
                                {title: 'Close Case', code: 'TNC_CLOSE_CASE'},
                                {title: 'Submit Case', code: 'SHOW_LATE_VERIFICATION', is_primary: true}
                            ];
                        } else {
                            self.actions = [
                                {title: 'Close Case', code: 'TNC_CLOSE_CASE'},
                                {title: 'Submit Case', code: 'START_CASE', is_primary: true}
                            ];
                        }

                        break;

                    case EVerifyAPI.STATUSES.UNCONFIRMED_DATA:
                        self.sectionSrc = '../modules/e-verify/components/cases-statuses/statuses/unconfirmed-data.html';

                        self.actions = [
                            {title: 'Close Case', code: 'TNC_CLOSE_CASE'},
                            {title: 'Confirm Data', code: 'CONFIRM_DATA', is_primary: true}
                        ];
                        break;

                    case EVerifyAPI.STATUSES.CLOSED:
                        self.sectionSrc = '../modules/e-verify/components/cases-statuses/statuses/closed.html';

                        self.actions = [];
                        break;

                    case EVerifyAPI.STATUSES.SCAN_AND_UPLOAD:
                        self.sectionSrc = '../modules/e-verify/components/cases-statuses/statuses/scan-and-upload.html';

                        self.actions = [
                            {title: 'Close Case', code: 'TNC_CLOSE_CASE', is_primary: true},
                            {title: 'Continue', code: 'CONTINUE_SCAN_UPLOAD_API', is_primary: true}
                        ];
                        break;

                    case EVerifyAPI.STATUSES.MANUAL_REVIEW:
                        self.sectionSrc = '../modules/e-verify/components/cases-statuses/statuses/manual-review.html';

                        self.actions = [];
                        break;

                    case EVerifyAPI.STATUSES.QUEUED:
                        self.sectionSrc = '../modules/e-verify/components/cases-statuses/statuses/queued.html';

                        self.actions = [];
                        break;

                    case EVerifyAPI.STATUSES.PENDING_REFERRAL:
                        self.sectionSrc = '../modules/e-verify/components/cases-statuses/statuses/ssa-dhs-tentative-non-confirmation.html';

                        self.actions = [
                            {title: 'Close Case', code: 'TNC_CLOSE_CASE'},
                            {title: 'Continue TNC', code: 'CONTINUE_TNC', is_primary: true}
                        ];

                        break;

                    case EVerifyAPI.STATUSES.REFERRED:
                        _handleChangingSections('CONTINUE_TNC');

                        break;

                    case EVerifyAPI.STATUSES.FINAL_NONCONFIRMATION:
                        self.sectionSrc = '../modules/e-verify/components/cases-statuses/statuses/final-nonconfirmation.html';

                        self.actions = [
                            {title: 'Close Case', code: 'TNC_CLOSE_CASE', is_primary: true}
                        ];

                        break;

                    case EVerifyAPI.STATUSES.EMPLOYMENT_AUTHORIZED:
                        self.sectionSrc = '../modules/e-verify/components/cases-statuses/statuses/authorized.html';

                        self.actions = [
                            {title: 'Close Case', code: 'TNC_CLOSE_CASE', is_primary: true}
                        ];
                        break;

                    case EVerifyAPI.STATUSES.CLOSE_CASE_AND_RESUBMIT:
                        self.sectionSrc = '../modules/e-verify/components/cases-statuses/statuses/unable-to-process.html';

                        self.actions = [
                            {title: 'Close Case', code: 'TNC_CLOSE_CASE', is_primary: true}
                        ];
                        break;

                    case EVerifyAPI.STATUSES.PHOTO_MATCH:
                        self.data.match_mode = 'MATCHING';
                        self.sectionSrc = '../modules/e-verify/components/cases-statuses/statuses/photo-matching-required.html';

                        self.actions = [
                            {title: 'Close Case', code: 'TNC_CLOSE_CASE'},
                            {title: 'Continue', code: 'CONTINUE_MATCHING_API', is_primary: true}
                        ];
                        break;
                }
            };

            var _confirmData = function () {
                return EVerifyAPI.confirmData(brand.id, self.user.id, self.everifyCase.id);
            };

            // start case when case status drafted
            // check duplicate cases before submit if there is duplicate case and no duplicate reason
            var _startCase = function () {
                var defer = $q.defer();

                EVerifyAPI.getDuplicatesCases(brand.id, self.user.id, self.everifyCase.id)
                    .then(function (res) {
                        self.duplicate_cases = res.cases || [];

                        if (self.duplicate_cases.length && !self.innerDetails['duplicate_continue_reason']) {
                            self.showDuplicateModal = true;

                            var data = {
                                late_reasons: self.late_reasons,
                                late_reason_other_txt: self.late_reason_other_txt,
                                phoneNumber: self.phoneNumber,
                                duplicate_cases: self.duplicate_cases
                            };

                            self.checkDuplicate({data: data});
                        } else {
                            return EVerifyAPI.startUserCase(brand.id, self.user.id, self.everifyCase.id);
                        }

                    })
                    .catch(function (err) {
                        self.everifyUtils.handleEVerifyErrorMessages(err, function () {
                            self.hide({statusCode: 'ERROR', data: err});
                        });
                    });

                return defer.promise;
            };

            // close the case api
            var _closeCase = function () {
                var otherReason = (self.data.closure_reason_code === 'OTHER' || self.data.closure_reason_code === 'OTHER_FREE_TEXT') ? self.other_reason_description : null;
                var employmentReason = self.data.closure_reason_code === 'EMPLOYEE_CONTINUES_TO_WORK_AFTER_FNC' ? self.currently_employed_reason_description : null;

                return EVerifyAPI.closeCase(
                    brand.id,
                    self.user.id,
                    self.everifyCase.id,
                    otherReason,
                    employmentReason,
                    self.data.closure_reason_code
                );
            };

            // handle changing on the progress tracker actions
            var _progressTrackerChangeHandle = function (itemId) {
                switch (itemId) {
                    case 'further_action_notice':
                        self.actions = [
                            {title: 'Close Case', code: 'TNC_CLOSE_CASE'},
                            {title: 'Save & Continue', code: 'TNC_SAVE_AND_CONTINUE', is_primary: true, disabled: !self.data.notified_employee}
                        ];

                        break;

                    case 'referral_date_confirmation':
                        self.actions = [];

                        break;
                }
            };

            // initiate the progress tacker for ssa-dhs-tentative nonConfirmation status
            var _progressTrackerTNCSection = function () {
                var progressTrackerItems = [
                    {
                        id: 'further_action_notice',
                        title: "Further Action Notice"
                    },
                    {
                        id: 'referral_date_confirmation',
                        title: "Referral Date Confirmation",
                        disabled: true
                    }
                ];

                if (self.everifyCase.status === 'EVerifyAPI.STATUSES.PENDING_REFERRAL') {
                    self.data.employee_will_take_action = self.data.employee_will_take_action || 'YES';
                }

                self.progressTrackerTNCSection = new ProgressTracker($scope, {
                    autoScroll: false,
                    items: progressTrackerItems,
                    onInitialized: function (element) {
                        switch (self.everifyCase.status) {
                            case EVerifyAPI.STATUSES.PENDING_REFERRAL:
                                self.progressTrackerTNCSection.goTo('further_action_notice');
                                _progressTrackerChangeHandle('further_action_notice');
                                break;

                            case EVerifyAPI.STATUSES.REFERRED:
                                self.progressTrackerTNCSection.changeState("further_action_notice", ProgressTracker.States.DONE);
                                self.progressTrackerTNCSection.changeState("referral_date_confirmation", ProgressTracker.States.NEW);
                                self.progressTrackerTNCSection.goTo('referral_date_confirmation');

                                _progressTrackerChangeHandle('referral_date_confirmation');
                                break;
                        }
                    },
                    onStateChanged: function (item, newState, oldState) {
                    },
                    onActiveChanged: function (activeItem, lastActiveItem) {
                        self.activeState = activeItem;
                    },
                    onItemClick: function (event, item) {
                        if (ProgressTracker.States.DONE !== item.state) {
                            self.progressTrackerTNCSection.goTo(item.id);
                            _progressTrackerChangeHandle(item.id);
                        }
                    }
                });
            };

            // get user attachment by document id so we can check it for the available extensions from e-verify
            var _getI9Document = function (loadAttachments) {
                var defer = $q.defer();

                var requestPayload = {
                    document_id: self.everifyCase.document_id,
                    attachments: true,
                    signed_url: true
                };

                OnBoardingAPI.getOnboardingUserDocuments(requestPayload)
                    .then(function (data) {
                        data[0].document.attachments = data[0].document.attachments || [];
                        var userAttachments = data[0].document.attachments.map(function (attachment) {
                            attachment.attachment_code_lookup = attachment.attachment_code_lookup || { name: attachment.custom_name };

                            return {
                                id: attachment.id,
                                code: attachment.attachment_code_lookup.code,
                                name: attachment.attachment_code_lookup.name,
                                extension: attachment.extension,
                                signed_url: attachment.signed_url,
                            };
                        });

                        var response = {
                            document: data[0].document,
                        };

                        if (loadAttachments) {
                            if (self.everifyCase.status === EVerifyAPI.STATUSES.SCAN_AND_UPLOAD) {
                                userAttachments.push({code: 'NEW_ATTACHMENT', name: 'Attach new...'});
                            }

                            response['userAttachments'] = userAttachments;
                        }

                        delete response.document.attachments;

                        defer.resolve(response);

                        $scope.$apply();
                    }, function (error) {
                        defer.reject(error);
                    });

                return defer.promise;
            };

            // validate tentative nonConfirmation on the refer section
            var _validateSections = function (action) {

                switch (action) {

                    case 'CONTINUE_SCAN_UPLOAD_API':
                        if (self.formValidation.validator.validate()) {
                            if (
                                (self.frontAttachmentCode === 'NEW_ATTACHMENT' && !self.uploadedFrontAttachment) ||
                                (self.backAttachmentCode === 'NEW_ATTACHMENT' && !self.uploadedBackAttachment)
                            ) {
                                hAlert('Attachment Required', 'Please upload front and/or back document png, pdf, gif or jpeg.', null, 'invalid-attachment-alert', '.e-verify-container');
                                return false;
                            }
                        } else {
                            return false;
                        }

                        break;

                    case 'DUPLICATE_CONTINUE_SAVE':
                    case 'FINAL_CLOSE_CASE':
                    case 'START_CASE':
                        return self.formValidation.validator.validate();
                }

                return true;
            };

            // this function to handle loading the needed sections from the action click code
            var _handleChangingSections = function (action, data) {

                switch (action) {
                    case 'CONTINUE_TNC':
                        self.sectionSrc = '../modules/e-verify/components/cases-statuses/actions/ssa-dhs-tentative-non-confirmation.html';

                        _progressTrackerTNCSection();

                        break;

                    case 'TNC_CLOSE_CASE':
                        self.onSectionLoad = function () {
                            self.formValidation = self.everifyUtils.getFormValidation($scope, 'close-case-form');
                            self.formValidation.onViewLoaded();
                        };

                        self.actions = [
                            {title: 'Back', code: 'BACK'},
                            {title: 'Close', code: 'FINAL_CLOSE_CASE', is_primary: true}
                        ];

                        self.sectionSrc = '../modules/e-verify/components/cases-statuses/actions/close-case.html';
                        break;

                    case 'BACK':
                        _logicShowCasesSections();
                        break;

                    case 'TNC_SAVE_AND_CONTINUE':
                        if (self.data.employee_will_take_action === 'YES') {
                            self.progressTrackerTNCSection.changeState("further_action_notice", ProgressTracker.States.DONE);
                            self.progressTrackerTNCSection.changeState("referral_date_confirmation", ProgressTracker.States.NEW);
                            self.progressTrackerTNCSection.goTo('referral_date_confirmation');

                            _progressTrackerChangeHandle('referral_date_confirmation');

                            self.actions = [];
                        } else {
                            var copyCase = angular.copy(self.everifyCase);
                            var copyData = angular.copy(data);
                            angular.extend(copyCase, copyData);

                            self.hide({statusCode: 'SUCCESS', data: copyCase});
                            break;
                        }

                        break;

                    case 'SHOW_LATE_VERIFICATION':
                        self.actions = [
                            {title: 'Submit Case', code: 'START_CASE', is_primary: true}
                        ];

                        self.sectionSrc = '../modules/e-verify/components/cases-statuses/actions/late-verification.html';
                        break;

                    case 'START_CASE':
                    case 'CONFIRM_DATA':
                    case 'CONTINUE_SCAN_UPLOAD_API':
                    case 'DUPLICATE_CONTINUE_SAVE':
                    case 'FINAL_CLOSE_CASE':
                    case 'CONTINUE_MATCHING_API':
                    case 'RESUBMIT_REVIEW_UPDATE_EMPLOYEE':
                        var copyCase = angular.copy(self.everifyCase);
                        var copyData = angular.copy(data);
                        angular.extend(copyCase, copyData);

                        self.hide({statusCode: 'SUCCESS', data: copyCase});
                        break;

                    case 'DUPLICATE_CONTINUE':
                        self.actions = [
                            {title: 'Back', code: 'DUPLICATE_BACK'},
                            {title: 'Continue', code: 'DUPLICATE_CONTINUE_SAVE', is_primary: true}
                        ];

                        self.showDuplicateContinueSection = true;

                        break;

                    case 'DUPLICATE_BACK':
                        self.formValidation.validator.validation = {};
                        delete self.data.reason_code;
                        delete self.data.other_reason;

                        self.actions = [
                            {title: 'Close Case', code: 'TNC_CLOSE_CASE'},
                            {title: 'Continue', code: 'DUPLICATE_CONTINUE', is_primary: true}
                        ];

                        self.showDuplicateContinueSection = false;
                        break;

                    case 'RESUBMIT':
                        self.onResubmit();
                        break;
                }
            };

            // the called after the employee is referd last section on the tentative non-confirmation
            var _handleConfirmContest = function () {
                var defer = $q.defer();
                delete self.userPrintedNotice;

                EVerifyAPI.furtherActionNotice(
                    brand.id,
                    self.user.id,
                    self.everifyCase.id,
                    self.data.notified_employee,
                    self.data.employee_will_take_action === 'YES'
                ).then(function (res) {
                    defer.resolve(res);
                }, function (err) {
                    defer.reject(err);
                });

                return defer.promise;
            };

            // this to continue the case if its duplicated
            var _handleContinueDuplicate = function () {
                if (self.data.reason_code !== 'OTHER') {
                    delete self.data.other_reason;
                }

                return EVerifyAPI.continueDuplicateCase(
                    brand.id,
                    self.user.id,
                    self.everifyCase.id,
                    self.data.reason_code,
                    self.data.other_reason
                );
            };

            // get the reasons for duplicate case
            var _handleGetDuplicateReasons = function () {
                var defer = $q.defer();

                EVerifyAPI.getDuplicateReasons()
                    .then(function (reasons) {
                        self.duplicateResons = reasons;
                        defer.resolve();
                        $scope.$digest();
                    }, function (err) {
                        defer.reject(err);
                    });

                return defer.promise;
            };

            // get closures cases
            var _handleGetCaseClosureReasons = function () {
                var defer = $q.defer();

                EVerifyAPI.getCaseClosureReasons(
                    brand.id,
                    self.user.id,
                    self.everifyCase.id
                ).then(function (reasons) {
                    self.caseClosureReasonsCodes = reasons;
                    defer.resolve();
                    $scope.$digest();
                }, function (err) {
                    defer.reject(err);

                    $scope.$digest();
                });

                return defer.promise;
            };

            var _getPhotoToConfirm = function () {
                return EVerifyAPI.getPhotoToConfirm(
                    brand.id,
                    self.user.id,
                    self.everifyCase.id
                );
            };

            var _handleContinueMatchingApi = function () {
                return EVerifyAPI.confirmMatchingPhoto(
                    brand.id,
                    self.user.id,
                    self.everifyCase.id,
                    self.data.match_mode
                );
            };

            var _handleContinueScanAndUploadApi = function () {
                var defer = $q.defer();
                var uploadedData = {};
                var uploadPromise = [];

                if (self.frontAttachmentCode) {
                    if (self.frontAttachmentCode === 'NEW_ATTACHMENT') {
                        uploadedData['front_attachment_file'] = self.uploadedFrontAttachment;
                    } else {
                        uploadedData['front_attachment_id'] = self.frontAttachment.id;
                    }
                }

                if (self.backAttachmentCode) {
                    if (self.backAttachmentCode === 'NEW_ATTACHMENT') {
                        uploadedData['back_attachment_file'] = self.uploadedBackAttachment;
                    } else {
                        uploadedData['back_attachment_id'] = self.backAttachment.id;
                    }
                }

                Upload.upload({
                    url: publicConfiguration.EVerifyServer + 'brands/' + brand.id + '/users/' + self.user.id + '/cases/' + self.everifyCase.id + '/verification_documents/upload',
                    withCredentials: true,
                    headers: {},
                    method: "POST",
                    data: uploadedData
                }).progress(function (evt) {
                }).success(function (data, status, headers, config) {
                    if (data && data.data) {
                        if (!document.employer_exclude_attachments) {
                            if (uploadedData['front_attachment_file']) {
                                uploadPromise.push(self.everifyUtils.uploadI9Documents(document, {
                                    file: uploadedData['front_attachment_file'],
                                    list: document.list,
                                    code: 'EVERIFY_SCAN_UPLOAD_FRONT'
                                }));
                            }

                            if (uploadedData['back_attachment_file']) {
                                uploadPromise.push(self.everifyUtils.uploadI9Documents(document, {
                                    file: uploadedData['back_attachment_file'],
                                    list: document.list,
                                    code: 'EVERIFY_SCAN_UPLOAD_BACK'
                                }));
                            }
                        }

                        $q.all(uploadPromise)
                            .then(function (uploadedDoc) {
                                defer.resolve(data.data);
                            }, function (error) {
                                self.everifyUtils.handleEVerifyErrorMessages(error);
                            });
                    }
                    else {
                        defer.reject(data);
                    }
                }).error(function (reason) {
                    defer.reject(reason);
                });

                return defer.promise;
            };

            var __handleResubmitEmployeeData = function () {
                return EVerifyAPI.resubmitCase(
                    brand.id,
                    self.user.id,
                    self.everifyCase.id
                );
            };
            // end private functions

            var validFileTypes = function (fileType, action, fileName) {
                if (action === 'CONTINUE_SCAN_UPLOAD_API') {
                    return (
                        fileType.indexOf("image/gif") > -1 ||
                        (fileType.indexOf("image/jpeg") > -1 && fileName.indexOf(".jpg") === -1) ||
                        fileType.indexOf("/pdf") > -1 ||
                        fileType.indexOf("image/png") > -1
                    );
                } else {
                    return (fileType.indexOf("image/jpg") > -1 || fileType.indexOf("image/gif") > -1 || fileType.indexOf("image/jpeg") > -1);
                }
            };

            self.notifyTheEmployeeChecked = function () {
                for (var i in self.actions) {
                    var action = self.actions[i];

                    if (action.code === 'TNC_SAVE_AND_CONTINUE') {
                        action.disabled = !self.data.notified_employee;
                        break;
                    }
                }
            };

            self.clearAttachment = function (fileCode) {
                if (fileCode === 'FRONT') {
                    delete self.uploadedFrontAttachment;
                } else {
                    delete self.uploadedBackAttachment;
                }
            };

            // file selected handle
            self.onFileSelected = function (files, action, fileCode) {
                if (files && files[0]) {

                    var fileType = Utils.getFileType(files[0]);
                    var fileName = files[0].name;

                    if (validFileTypes(fileType, action, fileName)) {

                        if (action === 'CONTINUE_SCAN_UPLOAD_API') {
                            if (files[0].size > 5000000) {
                                hAlert('Invalid Attachment', 'Attachment document should no greater than 5MB.', null, 'invalid-attachment-alert');
                            } else {
                                if (fileCode === 'FRONT') {
                                    self.uploadedFrontAttachment = files[0];
                                } else {
                                    self.uploadedBackAttachment = files[0];
                                }
                            }
                        } else {
                            self.uploadUserAttachment = files[0];
                            _validateSections(action);
                        }
                    }
                    else {
                        if (action === 'CONTINUE_SCAN_UPLOAD_API') {
                            hAlert('Invalid Attachment', 'Attachment document should be pdf, png, gif or jpeg.', null, 'invalid-attachment-alert');
                        } else {
                            hAlert('Invalid Attachment', 'Attachment document should be gif or jpg.', null, 'invalid-attachment-alert');
                        }
                    }
                }
            };

            // select user attachment
            self.selectAttachment = function (attachment) {
                self.selectedI9Document = attachment;
                self.selectedI9DocumentRequired = false;
                self.showUploadI9AttachmentButton = false;
                delete self.uploadUserAttachment;
            };

            // select print language
            self.selectLanguage = function (language, field) {
                self[field] = language;
            };

            // print function
            self.reprintNoticeEmployee = function (letterCode, languageField) {
                self.actionStarting = true;

                EVerifyAPI.getLettersS3Path(
                    brand.id,
                    self.user.id,
                    self.everifyCase.id,
                    letterCode,
                    self[languageField].code
                ).then(function (res) {
                    $("#e_verify_case_print_frame").attr("src", res);

                    setTimeout(function () {
                        delete self.actionStarting;
                        self.userPrintedNotice = true;
                        $scope.$digest();
                    }, 200);
                }, function (err) {

                    self.everifyUtils.handleEVerifyErrorMessages(err, function () {
                        delete self.actionStarting;
                        self.hide({statusCode: 'ERROR', data: err});
                    });

                    setTimeout(function () {
                        $scope.$digest();
                    }, 200);
                });
            };

            self.showUploadAttachmentButton = function() {
                delete self.selectedI9Document;
                self.showUploadI9AttachmentButton = true;
            };

            self.uploadedFileSelected = function (fileCode) {
                if (self.backAttachmentCode !== 'NEW_ATTACHMENT' && self.uploadedBackAttachment) {
                    self.clearAttachment('BACK');
                }

                if (self.frontAttachmentCode !== 'NEW_ATTACHMENT' && self.uploadedFrontAttachment) {
                    self.clearAttachment('FRONT');
                }

                var attachCode = fileCode === 'FRONT' ? self.frontAttachmentCode : self.backAttachmentCode;
                var attachment = _.findWhere(self.userAttachments, {code: attachCode});

                if (fileCode === 'FRONT') {
                    self.frontAttachment = attachment;
                } else {
                    self.backAttachment = attachment;
                }
            };

            // save the action
            self.saveAction = function (action) {

                if (!_validateSections(action)) {
                    return;
                }

                self.actionStarting = true;

                var promises = [];

                switch (action) {

                    case 'START_CASE':
                        promises.push(_startCase());
                        break;

                    case 'CONFIRM_DATA':
                        promises.push(_confirmData());
                        break;

                    case 'CONTINUE_SCAN_UPLOAD_API':
                        promises.push(_handleContinueScanAndUploadApi());
                        break;

                    case 'FINAL_CLOSE_CASE':
                        promises.push(_closeCase());
                        break;

                    case 'TNC_SAVE_AND_CONTINUE':

                        if(!self.userPrintedNotice) {
                            hAlert({
                                title: $filter("translate")("Print Further Action Notice (FAN) first"),
                                text: $filter("translate")("Please download the Further Action Notice (FAN) before referring the case."),
                                button: {text: "Okay"}
                            });
                            delete self.actionStarting
                            return;
                        } else {
                            promises.push(_handleConfirmContest());
                        }
                        break;

                    case 'DUPLICATE_CONTINUE':
                        promises.push(_handleGetDuplicateReasons());
                        break;

                    case 'DUPLICATE_CONTINUE_SAVE':
                        promises.push(_handleContinueDuplicate());
                        break;

                    case 'CONTINUE_MATCHING_API':
                        promises.push(_handleContinueMatchingApi());
                        break;

                    case 'TNC_CLOSE_CASE':
                        promises.push(_handleGetCaseClosureReasons());
                        break;

                    case 'RESUBMIT_REVIEW_UPDATE_EMPLOYEE':
                        promises.push(__handleResubmitEmployeeData());
                        break;
                }

                $q.all(promises)
                    .then(function (res) {
                        var data = res && res[0];

                        if (typeof (data) !== 'object') {
                            data = {};
                        }

                        data.external_details = data.external_details || {};

                        angular.extend(self.innerDetails, data.external_details);
                        angular.extend(self.everifyCase, data);
                        self.innerDetails['referral_date'] = data.vis_case && data.vis_case['referral_date'];

                        if (!self.showDuplicateModal) {
                            _handleChangingSections(action, data);
                        }

                        setTimeout(function () {
                            delete self.actionStarting;
                            $scope.$digest();
                        }, 200);
                    }, function (err) {
                        self.everifyUtils.handleEVerifyErrorMessages(err, function () {
                            delete self.actionStarting;
                            self.hide({statusCode: 'ERROR', data: err});
                        });
                    });
            };

            // init the components
            self.$onInit = function () {
                var promises = {};

                brand = self.modalData.brand;
                application_id = self.modalData.application_id;
                prospect_id = self.modalData.prospect_id;

                // start public attributes
                self.loading = true;
                self.data = {};
                self.actions = [];
                self.everifyCase = self.modalData.everify_case;
                self.user = self.modalData.user;
                self.isTermenated = self.modalData.employee_terminated;
                self.STATUSES = EVerifyAPI.STATUSES;
                self.ELIGIBILITY_EMPLOYMENT = EVerifyAPI.ELIGIBILITY_EMPLOYMENT;
                self.SSA_DHS_STATUSES = EVerifyAPI.SSA_DHS_STATUSES;
                self.PRINT_CODES = EVerifyAPI.PRINT_CODES;
                self.photoAttachmentOrMail = '';
                self.validI9Attachemtn = ['gif', 'jpg'];
                self.STATUSES_TEXT = EVerifyAPI.STATUSES_TEXT;
                self.SSA_DHS_TEXT = EVerifyAPI.SSA_DHS_TEXT;
                self.showDuplicateModal = false;

                self.noBtmPadding = [
                    self.STATUSES.SSA_TNC,
                    self.STATUSES.DHS_TNC,
                    self.STATUSES.PENDING_REFERRAL,
                    self.STATUSES.REFERRED
                ];

                self.languagesToPrint = [{
                    code: 'ENGLISH',
                    language: 'English'
                }, {
                    code: 'SPANISH',
                    language: 'Spanish'
                }];

                self.selectedLanguage = self.languagesToPrint[0];
                self.selectedLanguageConfirmation = self.languagesToPrint[0];

                self.innerDetails = {};
                self.metaData = {};

                self.documentsTypeTitle = OnBoardingAPI.DOCUMENT_CODES_TITLES;

                self.citizenshipCodes = {
                    US_CITIZEN: 'U.S. Citizen',
                    NON_CITIZEN: 'Non U.S. Citizen',
                    PERMENANT: 'Lawful Permanent Resident',
                    ALIEN_AUTH: 'Alien Authorized to Work'
                };

                promises['get_case_details'] = EVerifyAPI.getCaseDetails(brand.id, self.user.id, self.everifyCase.id);
                promises['attachments_lookups'] = OnBoardingAPI.getAttachmentCodeLookup();
                promises['latest_phone_number'] = EVerifyAPI.getLatestEmployerPhoneNumber(brand.id);

                $q.all(promises)
                    .then(function (responses) {
                        self.phoneNumber = responses['latest_phone_number'].phone_number;

                        promises = {};

                        if (responses['get_case_details']) {
                            self.caseDetails = responses['get_case_details'];

                            self.innerDetails = responses['get_case_details'].external_details;
                            self.metaData = responses['get_case_details'].meta_data && responses['get_case_details'].meta_data['external_details'] || {};
                            self.harriDetails = responses['get_case_details'].meta_data && responses['get_case_details'].meta_data['harri_details'] || {};

                            if (responses['get_case_details'].vis_case) {
                                self.innerDetails['eligibility_statement'] = responses['get_case_details'].vis_case['eligibility_statement'];
                                self.innerDetails['referral_date'] = responses['get_case_details'].vis_case['referral_date'];
                                self.innerDetails['dhs_status'] = responses['get_case_details'].vis_case['dhs_status'];
                                self.innerDetails['ssa_status'] = responses['get_case_details'].vis_case['ssa_status'];
                                self.innerDetails['submitted_on'] = responses['get_case_details'].vis_case['submitted_on'];
                            }

                            var updatedCase = {
                                document_id: self.caseDetails.document_id,
                                id: self.caseDetails.id,
                                job_id: self.caseDetails.job_id,
                                status: self.caseDetails.status,
                                sub_status: self.caseDetails.sub_status,
                                user_id: self.caseDetails.user_id
                            };

                            angular.extend(self.everifyCase, updatedCase);

                            if (self.caseDetails.started_by) {
                                self.moreDetailsLoading = true;
                                promises['get_user_main_details'] = UserAPI.getUserBasicDetails(self.caseDetails.started_by);
                            }
                        }

                        switch (self.everifyCase.status) {

                            case EVerifyAPI.STATUSES.PENDING_REFERRAL:
                            case EVerifyAPI.STATUSES.REFERRED:
                            case EVerifyAPI.STATUSES.SSA_TNC:
                            case EVerifyAPI.STATUSES.DHS_TNC:
                            case EVerifyAPI.STATUSES.SCAN_AND_UPLOAD:
                                var withAttachments = true;
                                promises['i9_document'] = _getI9Document(withAttachments);
                                break;

                            case EVerifyAPI.STATUSES.CLOSED:
                                var withAttachments = false;
                                promises['i9_document'] = _getI9Document(withAttachments);
                                promises['closure_reasons'] = EVerifyAPI.getClosureReasonsList();
                                break;

                            case EVerifyAPI.STATUSES.DRAFT:
                                var withAttachments = false;
                                promises['i9_document'] = _getI9Document(withAttachments);
                                break;

                            case EVerifyAPI.STATUSES.PHOTO_MATCH:
                                var withAttachments = true;
                                promises['i9_document'] = _getI9Document(withAttachments);
                                promises['photo_to_confirm'] = _getPhotoToConfirm();
                                break;
                        }

                        $q.all(promises)
                            .then(function (updatedPromise) {

                                if (updatedPromise['photo_to_confirm']) {
                                    self.photoToConfirmHref = updatedPromise['photo_to_confirm'];
                                }

                                self.CLOSURE_REASON = updatedPromise['closure_reasons'] || {};

                                var i9DocumentPromiseResponse = updatedPromise['i9_document'];

                                if (i9DocumentPromiseResponse) {
                                    document = i9DocumentPromiseResponse.document || {};

                                    if (i9DocumentPromiseResponse.userAttachments) {
                                        self.userAttachments = updatedPromise['i9_document'].userAttachments;
                                    }
                                }

                                if (updatedPromise['get_user_main_details']) {
                                    self.innerDetails['SubmittingOfficialName'] = (
                                        updatedPromise['get_user_main_details'].first_name +
                                        " " +
                                        updatedPromise['get_user_main_details'].last_name
                                    );
                                }

                                if (document) {
                                    // check if the last i9 is for this case because if the case has another i9 document
                                    // no action can done here
                                    // you can resubmit the case only if the last i9 document id is the same as the case that retrieved here
                                    self.thereIsI9Approved = (
                                        document.state === OnBoardingAPI.appStatuses.APPROVED &&
                                        self.everifyCase.document_id === document.id
                                    );
                                }

                                //when status DRAFT check late hired and duplicate reason before submit case
                                if (document && self.everifyCase.status === EVerifyAPI.STATUSES.DRAFT) {
                                    OnBoardingAPI.checkEVerifyStatus(brand.id, self.user.id, document.id)
                                        .then(function (check_everify) {
                                            self.checkEverifyStatus = check_everify || {};

                                            if (self.checkEverifyStatus.hire_date_past_due && !self.innerDetails['reason_for_delay_code']) {
                                                EVerifyAPI.getLateVerificationReasons()
                                                    .then(function (lateHireReasons) {
                                                        self.lateHireReasons = lateHireReasons;
                                                    })
                                                    .catch(function (err) {
                                                        self.everifyUtils.handleEVerifyErrorMessages(err, function () {
                                                            delete self.loading;
                                                            self.hide({statusCode: 'ERROR', data: err});
                                                        });
                                                    });
                                            }

                                            _logicShowCasesSections();

                                            delete self.moreDetailsLoading;
                                            delete self.loading;
                                            $scope.$digest();
                                        }, function (err) {
                                            self.everifyUtils.handleEVerifyErrorMessages(err, function () {
                                                delete self.loading;
                                                self.hide({statusCode: 'ERROR', data: err});
                                            });
                                        });
                                } else {
                                    _logicShowCasesSections();

                                    delete self.moreDetailsLoading;
                                    delete self.loading;
                                    $scope.$digest();
                                }
                            });
                    }, function (err) {
                        self.everifyUtils.handleEVerifyErrorMessages(err, function () {
                            self.loading = false;
                            self.hide({statusCode: 'ERROR', data: err});
                        });
                    });
            };
        }]
    };

    angular.module('harriApp.eVerify')
        .component('casesStatuses', CasesStatusesComponent);

})();
